import { Directive, ElementRef, Input, OnInit, OnChanges, SimpleChanges, Renderer2 } from '@angular/core';

@Directive({
  selector: '[bentoGridItem]',
  standalone: true
})
export class BentoGridItemDirective implements OnInit, OnChanges {
  @Input() bentoGridItemSpan: 1 | 2 = 1;
  @Input() bentoGridItemAriaLabel?: string;

  constructor(private readonly el: ElementRef,
  private readonly renderer: Renderer2) {}

  ngOnInit() {
    this.renderer.setAttribute(this.el.nativeElement, 'role', 'gridcell');
    if (this.bentoGridItemAriaLabel) {
      this.renderer.setAttribute(
        this.el.nativeElement,
        'aria-label',
        this.bentoGridItemAriaLabel
      );
    }
    this.updateSpan();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['bentoGridItemSpan']) {
      this.updateSpan();
    }
    if (changes['bentoGridItemAriaLabel']) {
      if (this.bentoGridItemAriaLabel) {
        this.renderer.setAttribute(
          this.el.nativeElement,
          'aria-label',
          this.bentoGridItemAriaLabel
        );
      } else {
        this.renderer.removeAttribute(this.el.nativeElement, 'aria-label');
      }
    }
  }

  private updateSpan() {
    // Remove any existing span classes first
    this.renderer.removeClass(this.el.nativeElement, 'tw-col-span-1');
    this.renderer.removeClass(this.el.nativeElement, 'tw-col-span-2');
    // Add the new span class
    this.renderer.addClass(
      this.el.nativeElement,
      `tw-col-span-${this.bentoGridItemSpan}`
    );
  }
}
